<template>
  <div class="hm-info-container">
    <div class="hm-name" :title="hmInfo.name" @click="changeButtonStatus()">{{ hmInfo.name }}</div>
    <i class="hm-info-arrow" @click="changeButtonStatus()" :class="showButton ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    <div class="operate-container" v-show="showButton">
      <div class="operate-item dashboard" v-if='showHomePage' @click="handelToHome()">{{ $t('hm.btn.homePage') }}</div>
      <div class="operate-item logout" @click="handelLogout()">{{ $t('hm.btn.signOnt') }}</div>
    </div>
  </div>
</template>

<script>
import { ACCOUNT_TYPE } from '@/constant/common'
import { mapActions } from 'vuex'
import mixin from '../../common/mixin'

export default {
  mixins: [mixin],
  components: {

  },
  props: {
    showHomePage: {
      default: true
    }
  },
  data () {
    return {
      showButton: false
    }
  },
  computed: {
  },
  created () {
    this.initHmInfo()
  },
  beforeDestroy () {

  },
  methods: {
    ...mapActions('hm', ['setToken']),
    changeButtonStatus () {
      this.showButton = !this.showButton
    },
    handelLogout () {
      this.setToken()
      this.$router.push(`/passport/${ACCOUNT_TYPE.HIRING_MANAGER}/login`)
    },
    handelToHome () {
      this.$router.push({ name: 'interviewPage' })
    }
  }
}
</script>

<style lang="scss" scoped>
.hm-info-container {
  background-color: #606060;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  position: relative;
  padding: 7.5px 15px;
  height: 35px;

  .hm-name {
    width: 200px;
    overflow: hidden;
    cursor: pointer;
    white-space: nowrap;
    word-break: keep-all;
    text-overflow: ellipsis;
  }

  .hm-info-arrow {
    cursor: pointer;
  }

  .operate-container {
    position: absolute;
    top: 53px;
    width: 246px;
    left: 0;
    background-color: #606060;
    font-weight: 300;

    .operate-item {
      padding: 14px 15px;
      &:last-child {
        border-bottom: unset;
      }
    }
    .operate-item:hover{
      cursor:pointer;
      background: #0c0c0c;
    }
  }
}
</style>
